import React from 'react';

import styles from './AiChatbot.module.scss';

export function DateMessage({ text }) {
  return (
    <div className={styles['date-message']}>
      <span>{text}</span>
    </div>
  );
}
